import React, { useRef } from 'react';
import ContainerDimensions from 'react-container-dimensions';
import config from 'react-global-configuration';

import {
  SearchKit,
  SearchLoadMore,
} from '@uncinc/uncinc-react-kitchen-sink';

import Filters from '../../components/Search/Filters';
import SearchResults from '../../components/Search/List';
import MapSearch from '../../components/Search/Map';
import { MapContextProvider } from './MapContext';

import * as query from './query.graphql';
import './style.scss';

const Map = ({ children }) => {
  const scrollView = useRef();

  return (
    <div className="MapPage">
      <SearchKit
        uri={config.get('APOLLO_SEARCH_URL')}
        query={query}
        pageSize={100}
      >
        {
          (data, loading) => {
            if (!data) {
              return;
            }

            return (
              <MapContextProvider>
                <Filters />
                <div className="Content">
                  <div className="Content__results" ref={scrollView}>
                    <SearchResults
                      data={data.nLDoetSearch}
                      scrollView={scrollView}
                    />
                    <SearchLoadMore data={data.nLDoetSearch} label="Laat meer resultaten zien" />
                  </div>
                  <ContainerDimensions>
                    <MapSearch />
                  </ContainerDimensions>
                </div>
              </MapContextProvider>
            );
          }
        }
      </SearchKit>
    </div>
  );
};

export default Map;
